interface FilterBarProps {
  searchName: string;
  setSearchName: (v: string) => void;
  searchRoom: string;
  setSearchRoom: (v: string) => void;
  activeFilter: string;
  setActiveFilter: (v: string) => void;
  channelFilter: string;
  setChannelFilter: (v: string) => void;
  opStatusFilter: string;
  setOpStatusFilter: (v: string) => void;
  showPast: boolean;
  setShowPast: (v: boolean) => void;
  allChannels: string[];
  allOpStatuses: string[];
  today: string;
}

const FILTER_OPTIONS = [
  { key: 'upcoming', label: '今後' },
  { key: 'today_arrival', label: '本日到着' },
  { key: 'today_departure', label: '本日出発' },
  { key: 'in_house', label: '滞在中' },
  { key: 'past', label: '過去' },
];

const CHANNEL_LABELS: Record<string, string> = {
  direct: '直接予約',
  airbnb: 'Airbnb',
  booking: 'Booking.com',
  trip: 'Trip.com',
  expedia: 'Expedia',
  phone: '電話',
  walk_in: '飛び込み',
  other: 'その他',
};

const OP_STATUS_LABELS: Record<string, string> = {
  expected: '予定',
  checked_in: '滞在中',
  checked_out: '退室済',
  no_show: 'ノーショー',
  cancelled: 'キャンセル',
};

export default function FilterBar({
  searchName, setSearchName,
  searchRoom, setSearchRoom,
  activeFilter, setActiveFilter,
  channelFilter, setChannelFilter,
  opStatusFilter, setOpStatusFilter,
  showPast, setShowPast,
  allChannels, allOpStatuses,
}: FilterBarProps) {
  return (
    <div className="space-y-3 mb-4">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-foreground-400">
            <i className="ri-search-line text-sm"></i>
          </span>
          <input
            type="text"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder="ゲスト名で検索..."
            className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
        </div>
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-foreground-400">
            <i className="ri-hotel-line text-sm"></i>
          </span>
          <input
            type="text"
            value={searchRoom}
            onChange={(e) => setSearchRoom(e.target.value)}
            placeholder="部屋名で検索..."
            className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1 bg-background-100 rounded-full px-1 py-1">
          {FILTER_OPTIONS.map((opt) => (
            <button
              key={opt.key}
              onClick={() => {
                setActiveFilter(opt.key);
                if (opt.key === 'past') setShowPast(true);
              }}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeFilter === opt.key
                  ? 'bg-background-50 text-foreground-900 shadow-sm'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>

        <div className="w-px h-6 bg-background-200/70 hidden sm:block" />

        <select
          value={channelFilter}
          onChange={(e) => setChannelFilter(e.target.value)}
          className="text-xs px-3 py-1.5 rounded-full border border-background-200/70 bg-background-50 text-foreground-700 cursor-pointer focus:outline-none focus:border-primary-400"
        >
          <option value="">予約経路: すべて</option>
          {allChannels.map((ch) => (
            <option key={ch} value={ch}>{CHANNEL_LABELS[ch] || ch}</option>
          ))}
        </select>

        <select
          value={opStatusFilter}
          onChange={(e) => setOpStatusFilter(e.target.value)}
          className="text-xs px-3 py-1.5 rounded-full border border-background-200/70 bg-background-50 text-foreground-700 cursor-pointer focus:outline-none focus:border-primary-400"
        >
          <option value="">現場状態: すべて</option>
          {allOpStatuses.map((s) => (
            <option key={s} value={s}>{OP_STATUS_LABELS[s] || s}</option>
          ))}
        </select>

        <label className="flex items-center gap-1.5 text-xs text-foreground-500 cursor-pointer ml-auto">
          <input
            type="checkbox"
            checked={showPast}
            onChange={(e) => setShowPast(e.target.checked)}
            className="w-3.5 h-3.5 rounded border-background-300 cursor-pointer accent-primary-500"
          />
          過去を表示
        </label>
      </div>
    </div>
  );
}